import {useEffect, useState} from 'react';
import {useServiciosHogarPlanes} from "hooks/useServiciosHogarPlanes";
// import Search from "components/ServiciosHogarPlanes/Search";
import Form from "components/ServiciosHogarPlanes/Form";
import Table from "components/ServiciosHogarPlanes/Table";
import SpinnerBootrap from 'components/SpinnerBootrap';

const HOGARPLAN_ESTADO = {
    image: false,
    subcategory: false, 
    plan: true,
    benefits: true,
    unitPrice: true,
    comboPrice: true,
    isActive: true
}

function ServiciosHogarPlanes(){
 const {
    hogarPlanes, 
    loading, 
    page, 
    totalPages, 
    status, 
    deleteHogarPlan, 
    updateHogarPlan, 
    createHogarPlan, 
    getHogarPlanes, 
    setPage
} = useServiciosHogarPlanes();

 const [isSearched, setIsSearched] = useState({
     search: '',
     option: '',
     state: false
 })


 const [category, setCategory] = useState("internet");
 const [formEstado, setFormEstado] = useState(HOGARPLAN_ESTADO)
 

 useEffect(() => {
    if(status !== 401 ) return
    localStorage.removeItem('token')
    window.location.href="/login"
 }, [status])

 useEffect(() => {
  getHogarPlanes({category});
  // eslint-disable-next-line
 }, [category])

 return (
 <div className="container">
     <div className="row my-md-4">
         <h4 className="d-flex justify-content-center">Gestión de Planes de Servicio Hogar</h4>
        
         <div className="py-3 d-flex align-items-center">
            <h5 className="m-0 me-4">
                <span className="badge bg-danger" style={{"textAlign": "left"}}>SELECCIONA UNA<br></br> CATEGORÍA: </span> 
            </h5>
            <div style={{flex: 1}}>
                <ul className="nav nav-pills nav-fill">
                    <li className="nav-item" style={{cursor: "pointer"}} onClick={() => setCategory('internet')}>
                        <span className={`nav-link ${category === 'internet' && "active"}`}>Internet</span>
                    </li>
                    <li className="nav-item" style={{cursor: "pointer"}} onClick={() => setCategory('television')}>
                        <span className={`nav-link ${category === 'television' && "active"}`}>Televisión</span>
                    </li>
                    <li className="nav-item" style={{cursor: "pointer"}} onClick={() => setCategory('telefonia')}>
                        <span className={`nav-link ${category === 'telefonia' && "active"}`}>Telefonía</span>
                    </li>
                    <li className="nav-item" style={{cursor: "pointer"}} onClick={() => setCategory('adicionales')}>
                        <span className={`nav-link ${category === 'adicionales' && "active"}`}>Adicionales</span>
                    </li>
                </ul>
            </div>
         </div>
         <h1 className="text-center m-0 mt-3 mb-1" style={{"textTransform": "uppercase"}}>{category}</h1>
         {/* <div className="col-12">
             <Search getHogarPlanes={getHogarPlanes} setIsSearched={setIsSearched} />
         </div> */}
         <div className="col-12">
             <Form createHogarPlan={createHogarPlan} updateHogarPlan={updateHogarPlan} setIsSearched={setIsSearched} category={category} formEstado={formEstado} setFormEstado={setFormEstado}/>
         </div>
         <div className="col-12">
             {loading && <SpinnerBootrap/>}
             <Table hogarPlanes={hogarPlanes} getHogarPlanes={getHogarPlanes} deleteHogarPlan={deleteHogarPlan} totalPages={totalPages} setPage={setPage} page={page} isSearched={isSearched} setIsSearched={setIsSearched} formEstado={formEstado} category={category}/>
         </div>
     </div>
 </div>
 )
}

export default ServiciosHogarPlanes